<template>
  <div class="verification-form__wrap">
    <div class="verification-form">
      <md-progress-bar md-mode="indeterminate" v-if="isPending"/>
      <div class="verification-form__title text_large">{{ i18n.kyc_form_submit() }}</div>
      <md-steppers :md-linear="isLinear"
                   :md-vertical="!isLinear"
                   :md-active-step.sync="activeStep"
                   :md-dynamic-height="!isLinear"
                   md-dynamic-height
      >
        <md-step v-for="(step, i) in steps"
                 :key="i"
                 :id="step.name"
                 :md-label="step.label"
                 :md-done.sync="step.done"
        >
          <component :is="step.component"
                     :schema="step.schema"
                     :activeStep="activeStep"
                     :finalStep="finalStep"
                     :kyc="kyc"
                     @kyc-update="handleKycUpdate($event, { step, i })"
                     @kyc-edit-end="handleKycEditEnd"
          />
        </md-step>
      </md-steppers>
    </div>
  </div>
</template>

<script>
  import FormMixin from '@com/mixins/form.mixin'
  import steps from '../spec/kyc-steps.syndicate.schema'
  import { i18n } from '@js/i18n'
  import { mapGetters, mapActions } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import { accountsService } from '@api/accounts.service'
  import {
    userTypes,
    blobTypes,
    ACCOUNT_TYPES,
    ACCOUNT_STATES
  } from '@const'
  import { confirmAction } from '@js/modals/confirmation_message'
  import { EventDispatcher } from '@js/events/event_dispatcher'
  import { ErrorHandler } from '@js/errors/error_handler'
  import { KycTemplateParser } from '../spec/kyc-template-parser'

  const KYC_LEVEL_TO_SET = 0
  export default {
    name: 'verification-index',
    components: {},
    mixins: [FormMixin],
    data: _ => ({
      activeStep: steps[0].name,
      finalStep: steps[steps.length - 1].name,
      kyc: null,
      i18n,
      steps,
      ACCOUNT_TYPES,
      isLinear: false
    }),
    async created () {
      await Promise.all([
        this.loadTokens(),
        this.loadBalances()
      ])
      this.kyc = KycTemplateParser.fromTemplate(this.accountKycData, userTypes.syndicate)

      this.checkWindowWidth()
      window.addEventListener('resize', () => {
        this.checkWindowWidth()
      })
    },

    computed: {
      ...mapGetters([
        vuexTypes.accountId,
        vuexTypes.accountTypeI,
        vuexTypes.accountKycLatestRequest,
        vuexTypes.accountKycData,
        vuexTypes.accountState
      ])
    },

    methods: {
      ...mapActions({
        loadTokens: vuexTypes.GET_ALL_TOKENS,
        loadBalances: vuexTypes.GET_ACCOUNT_BALANCES,
        loadKycRequests: vuexTypes.GET_ACCOUNT_KYC_REQUESTS,
        updateKycData: vuexTypes.UPDATE_ACCOUNT_KYC_DATA,
        updateDocuments: vuexTypes.UPDATE_ACCOUNT_KYC_DOCUMENTS
      }),

      handleKycUpdate ({ form, documents, finalize }, { step, i }) {
        form = form || {}
        documents = documents || {}
        Object.entries(form).forEach(([key, value]) => {
          this.kyc[key] = value
        })
        Object.entries(documents).forEach(([key, value]) => {
          this.kyc.documents[key] = value
        })
        const lastStep = this.activeStep === this.steps[this.steps.length - 1].name
        if (finalize && lastStep) {
          this.handleKycEditEnd()
        }
        if (!lastStep) {
          this.activeStep = (this.steps[i + 1] || this.steps[0]).name
        }
        step.done = true
      },
      async handleKycEditEnd () {
        if (!await confirmAction()) return
        this.disable()

        try {
          await this.updateDocuments(this.kyc.documents)
          const blobId = await this.updateKycData({
            details: KycTemplateParser.toTemplate(this.kyc, userTypes.syndicate),
            documents: KycTemplateParser.getSaveableDocuments(this.kyc.documents),
            blobType: blobTypes.syndicate_kyc.str
          })
          await this.submitRequest(blobId)
          EventDispatcher.dispatchShowSuccessEvent(i18n.kyc_upload_success())
          this.$router.push({name: 'verification.make', params: {}})
        } catch (error) {
          console.error(error)
          ErrorHandler.processUnexpected(error)
        }
        try {
          await this.loadKycRequests() // moved from first try-catch. Reason: session storage is full when loading the entire set of documents and causes an error notification
        } catch (error) {
          console.error(error)
        }
        this.enable()
      },

      async submitRequest (blobId) {
        await accountsService.createKycRequest({
          requestID: this.accountState === ACCOUNT_STATES.rejected ? this.accountKycLatestRequest.id : '0',
          accountToUpdateKYC: this.accountId,
          accountTypeToSet: ACCOUNT_TYPES.syndicate,
          kycLevelToSet: KYC_LEVEL_TO_SET,
          kycData: { blob_id: blobId }
        })
      },
      checkWindowWidth () {
        this.isLinear = window.innerWidth > 1500
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './verification.scss';

</style>



// WEBPACK FOOTER //
// src/vue/app/verification/make/Verification.Syndicate.vue